/** A prefilled value shown, not edited, at most this high before it scrolls. */
export const VALUE_PREVIEW_CLASS = "app-surface-muted app-text max-h-32 overflow-auto whitespace-pre-wrap rounded p-1.5 text-xs";

/**
 * A filled value at a glance that opens to its whole text, as the step's prompt holds it (F148): an input to expand
 * before the step runs, closed by default so a long label list or entry doesn't push the step out of view.
 */
export default function FilledText({ summary, text, asTitle = false }: { readonly summary: string; readonly text: string; readonly asTitle?: boolean }) {
  return (
    <details>
      <summary className={asTitle ? "app-text cursor-pointer truncate text-sm font-medium" : "app-text cursor-pointer truncate text-xs"}>{summary}</summary>
      <p className={`${VALUE_PREVIEW_CLASS} mt-1 max-h-64`}>{text}</p>
    </details>
  );
}
